import React, { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import "./App.css";
import Loader from "./components/loader/Loader";

import { ConfigProvider } from "antd";
import arEG from "antd/locale/ar_EG";
import enUS from "antd/locale/en_US";
import dayjs from "dayjs";
import * as localizedFormat from "dayjs/plugin/localizedFormat";
import * as preParsePostFormat from "dayjs/plugin/preParsePostFormat";
import TagManager from "react-gtm-module";
import { useTranslation } from "react-i18next";
import AllRoutes from "./routes";
import "./utils/ar_24";
import ScrollToAnchor from "./utils/scrollToSection";
import Hotjar from '@hotjar/browser';

dayjs.extend(localizedFormat);
dayjs.extend(preParsePostFormat);
dayjs().locale("ar").format("LLL");

function useHotjarTracking() {
  const location = useLocation();

  useEffect(() => {
    if (
      process.env.REACT_APP_NODE_ENV === "production" ||
      process.env.REACT_APP_NODE_ENV === "test"
    ) {
      const hotjarId = process.env.REACT_APP_NODE_ENV === "production" ? 5093725 : 5092523;
      Hotjar.init(hotjarId, 6);
      console.log("✅ Hotjar initialized");
    }
  }, []);

  useEffect(() => {
    Hotjar.stateChange(location.pathname);
  }, [location]);
}


function HotjarTracker() {
  useHotjarTracking();
  return null; // no UI output
}

function App() {
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-KZ2N2DTR",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <BrowserRouter>
      <HotjarTracker />
      <ScrollToAnchor />
      <Loader />
      <ConfigProvider locale={language === "en" ? enUS : arEG}>
        <AllRoutes />
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
